import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer"; // Import the Footer component
import AboutSchool from "./pages/AboutUs/AboutSchool";
import MissionVision from "./pages/AboutUs/MissionVision";
import PrincipalMessage from "./pages/AboutUs/PrincipalMessage";
import ContactUs from "./pages/AboutUs/ContactUs";
import AimsObjective from "./pages/AcademicInformation/AimsObjective";
import SchoolHours from "./pages/AcademicInformation/SchoolHours";
import SchoolSection from "./pages/AcademicInformation/SchoolSection";
import WhyThisSchool from "./pages/AcademicInformation/WhyThisSchool";
import NewApplicationForm from "./pages/Admission/NewApplicationForm";
import FeeStructure from "./pages/Admission/FeeStructure";
import Photos from "./pages/Gallery/Photos";
import Videos from "./pages/Gallery/Videos";
import StudentLogin from "./Student/StudentLogin"
import HeroSection from "./components/Navbar/HeroSection";
import AdminLogin from "./Admin/AdminLogin";
import AnnualPage from './pages/Gallery/AnnualPage';
import Annual2025Page from './pages/Gallery/Annual2025Page';
import MedicinalPage from './pages/Gallery/MedicinalPage';
import PicnicPage from './pages/Gallery/PicnicPage';
import OtherEventsPage from './pages/Gallery/OtherEventsPage';
import HiringPopup from "./components/HiringPopup"; 


function App() {
  return (
    <Router>
        <HiringPopup />
      <Navbar />
      <Routes>
        {/* About Us Routes */}
        <Route path="/about-school" element={<AboutSchool />} />
        <Route path="/mission-vision" element={<MissionVision />} />
        <Route path="/principal-message" element={<PrincipalMessage />} />
        <Route path="/contact-us" element={<ContactUs />} />

        {/* Academic Information Routes */}
        <Route path="/aims-objective" element={<AimsObjective />} />
        <Route path="/school-hours" element={<SchoolHours />} />
        <Route path="/school-section" element={<SchoolSection />} />
     
        <Route path="/why-this-school" element={<WhyThisSchool />} />

        {/* Admission Routes */}
        <Route path="/new-application-form" element={<NewApplicationForm />} />
        <Route path="/fee-structure" element={<FeeStructure />} />

        {/* Gallery Routes */}
        <Route path="/photos" element={<Photos />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/gallery/annual" element={<AnnualPage />} />
        <Route path="/gallery/annual-2025" element={<Annual2025Page />} />
<Route path="/gallery/medicinal" element={<MedicinalPage />} />
<Route path="/gallery/picnic" element={<PicnicPage />} />
<Route path="/gallery/other" element={<OtherEventsPage />} />

        {/* Login Routes */}
        <Route path="/student-login" element={<StudentLogin />} />
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* Home Route */}
        <Route path="/" element={<HeroSection />} /> 
      </Routes>

      {/* Footer Component */}
      <Footer />
    </Router>
  );
}

export default App;
